import { render, staticRenderFns } from "./globalCategoryModal.vue?vue&type=template&id=4596b132"
import script from "./globalCategoryModal.vue?vue&type=script&lang=js"
export * from "./globalCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports